import api from "../lib/api";

export const offersService = {
    getAvailableRequests: () => api.get('/company/quotes/requests'),
    getCompanyOffers: () => api.get('/company/offers'),
    getAcceptedOffers: () => api.get('/company/offers/accepted'),
    createOffer: (quoteId, data) => api.post(`/company/quotes/${quoteId}/offers`, data),
    updateOffer: (offerId, data) => api.put(`/company/offers/${offerId}`, data),
    deleteOffer: (offerId) => api.delete(`/company/offers/${offerId}`),
    getOfferById: (offerId) => api.get(`/company/offers/${offerId}`),
};